// extracted by mini-css-extract-plugin
export var ctaBanner = "index-module--ctaBanner--3e938";
export var ctaBannerItem = "index-module--ctaBannerItem--c77cd";
export var ctaBannerItemSpan = "index-module--ctaBannerItemSpan--d70c4";
export var ctaBannerWrapper = "index-module--ctaBannerWrapper--2fccd";